import CobrancaPage from "../Cobranca";
import VinculosAtivosPage from "./VinculosAtivosPage";
import VinculosEncerradosPage from "./VinculosEncerradosPage";

export const CobrancaAtivosPage: React.FC = () => {
  return <VinculosAtivosPage />;
};

export const CobrancaEncerradosPage: React.FC = () => {
  return <VinculosEncerradosPage />;
};

export const CobrancaRelatorioPage: React.FC = () => {
  return <CobrancaPage type="RELATORIO" />;
};